import React from 'react';
import PropTypes from "prop-types";
import { EuiMarkdownFormat, getDefaultEuiMarkdownProcessingPlugins } from '../../../../src/components/markdown_editor';
import { slugify } from '../../../../src/services';
export var GuideMarkdownFormat = ({
  children,
  ...rest
}) => {
  const processingPlugins = getDefaultEuiMarkdownProcessingPlugins();
  const rehype2reactConfig = processingPlugins[1][1];

  rehype2reactConfig.components.h2 = ({
    children
  }) => {
    const id = slugify(children[0]);
    return <h2 id={id}>{children}</h2>;
  };

  return <EuiMarkdownFormat processingPluginList={processingPlugins} className="guideMarkdownFormat" textSize="m" {...rest}>
      {children}
    </EuiMarkdownFormat>;
};
GuideMarkdownFormat.propTypes = {
  className: PropTypes.string,
  "aria-label": PropTypes.string,
  "data-test-subj": PropTypes.string,
  children: PropTypes.string.isRequired,

  /** array of unified plugins to parse content into an AST */
  parsingPluginList: PropTypes.any,

  /** array of unified plugins to convert the AST into a ReactNode */
  processingPluginList: PropTypes.any,

  /**
       * Determines the text size. Choose `relative` to control the `font-size` based on the value of a parent container.
       */
  textSize: PropTypes.oneOf(["xs", "s", "m", "relative"])
};

try {
  GuideMarkdownFormat.__docgenInfo = {
    tags: {},
    filePath: '/app/src-docs/src/components/guide_markdown_format/guide_markdown_format.tsx',
    description: '',
    displayName: 'GuideMarkdownFormat',
    methods: [],
    props: {
      className: {
        defaultValue: null,
        description: '',
        name: 'className',
        parent: {
          fileName: 'app/src/components/common.ts',
          name: 'CommonProps'
        },
        declarations: [{
          fileName: 'app/src/components/common.ts',
          name: 'CommonProps'
        }, {
          fileName: 'app/src/components/common.ts',
          name: 'CommonProps'
        }, {
          fileName: 'app/node_modules/@types/react/index.d.ts',
          name: 'HTMLAttributes'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      'aria-label': {
        defaultValue: null,
        description: 'Defines a string value that labels the current element.\n' + '@see aria-labelledby.',
        name: 'aria-label',
        parent: {
          fileName: 'app/src/components/common.ts',
          name: 'CommonProps'
        },
        declarations: [{
          fileName: 'app/src/components/common.ts',
          name: 'CommonProps'
        }, {
          fileName: 'app/src/components/common.ts',
          name: 'CommonProps'
        }, {
          fileName: 'app/node_modules/@types/react/index.d.ts',
          name: 'AriaAttributes'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      'data-test-subj': {
        defaultValue: null,
        description: '',
        name: 'data-test-subj',
        parent: {
          fileName: 'app/src/components/common.ts',
          name: 'CommonProps'
        },
        declarations: [{
          fileName: 'app/src/components/common.ts',
          name: 'CommonProps'
        }, {
          fileName: 'app/src/components/common.ts',
          name: 'CommonProps'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      color: {
        defaultValue: null,
        description: 'Any of our named colors or a `hex`, `rgb` or `rgba` value.',
        name: 'color',
        parent: undefined,
        declarations: [{
          fileName: 'app/src/components/text/text.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: '"default" | "accent" | "success" | "warning" | "danger" | "ghost" | "subdued" | Color'
        }
      },
      textAlign: {
        defaultValue: null,
        description: '',
        name: 'textAlign',
        parent: undefined,
        declarations: [{
          fileName: 'app/src/components/text/text.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'enum',
          raw: '"left" | "right" | "center"',
          value: [{
            value: '"left"'
          }, {
            value: '"right"'
          }, {
            value: '"center"'
          }]
        }
      },
      grow: {
        defaultValue: null,
        description: '',
        name: 'grow',
        parent: undefined,
        declarations: [{
          fileName: 'app/src/components/text/text.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'boolean'
        }
      },
      parsingPluginList: {
        defaultValue: null,
        description: 'array of unified plugins to parse content into an AST',
        name: 'parsingPluginList',
        parent: undefined,
        declarations: [{
          fileName: 'app/src/components/markdown_editor/markdown_format.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'PluggableList<Settings>'
        }
      },
      processingPluginList: {
        defaultValue: null,
        description: 'array of unified plugins to convert the AST into a ReactNode',
        name: 'processingPluginList',
        parent: undefined,
        declarations: [{
          fileName: 'app/src/components/markdown_editor/markdown_format.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'PluggableList<Settings>'
        }
      },
      textSize: {
        defaultValue: null,
        description: 'Determines the text size. Choose `relative` to control the `font-size` based on the value of a parent container.',
        name: 'textSize',
        parent: undefined,
        declarations: [{
          fileName: 'app/src/components/markdown_editor/markdown_format.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'enum',
          raw: '"xs" | "s" | "m" | "relative"',
          value: [{
            value: '"xs"'
          }, {
            value: '"s"'
          }, {
            value: '"m"'
          }, {
            value: '"relative"'
          }]
        }
      }
    },
    extendedInterfaces: ['CommonProps', 'HTMLAttributes', 'AriaAttributes', 'DOMAttributes']
  };
} catch (e) {}